import React, { useRef, useState } from "react";
import Triage from "./Triage";
import { useLocation } from "react-router-dom";
import ActionManagement from "./ActionManagement";
import { useCommonContext } from "../../context/CommonContext";
import ModalBox from "../elements/ModalBox/ModalBox";
import Textinput from "../elements/TextInput/TextInput";
import Button from "../elements/Button/Button";
import CryptoJS from "crypto-js";
import ClipLoader from "react-spinners/ClipLoader";
import Swal from "sweetalert2";

const EmailSidebar = () => {
  const { section, setSection } = useCommonContext();
  const [currentParsingText, setParsingText] = useState("");
  const [naukriParsing, setNaukriParsing] = useState("");
  const [modifiedTime, setModifiedTime] = useState("");
  const [currentMail, setCurrentEmail] = useState("");
  const [eeezoOpen, setEeezoOpen] = useState("");
  const [naukriOpen, setNaukriOpen] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const newParse = useRef(null);
  const location = useLocation();
  const [currentSection, setCurrentSection] = useState("Email Dashboard");

  const handleSections = (value) => {
    setCurrentSection(value);
    if (value === "Schedule") {
      setSection("eeezo");
    } else if (value === "naukri") {
      setSection("naukri");
    } else {
      setSection("");
    }
    // Close sidebar on mobile after selection
    setIsSidebarOpen(false);
  };

  const handleschedule = async () => {
    console.log("settings....");
    var userId;
    const encryptedMetadata = localStorage.getItem("metadata");
    if (encryptedMetadata) {
      const decryptedMetadata = JSON.parse(
        CryptoJS.AES.decrypt(
          encryptedMetadata,
          process.env.REACT_APP_SECRETKEY
        ).toString(CryptoJS.enc.Utf8)
      );
      if (decryptedMetadata.cid) {
        userId = Number(decryptedMetadata.uid);
      }
    }
    console.log("opening userid:::", userId);
    const parseValue = { userID: userId, type: "eeezo" };
    try {
      const serverURL = process.env.REACT_APP_SERVER_URL;
      console.log("Fetching parsing text details...");
      const encryptedData = CryptoJS.AES.encrypt(
        JSON.stringify(parseValue),
        process.env.REACT_APP_SECRETKEY
      ).toString();

      const response = await fetch(`${serverURL}/Triage/getParseText`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ data: encryptedData }),
      });
      const result = await response.json();
      console.log("Server Response getsync:", result);
      setCurrentEmail(result.data["emails"][0]["syncmail"]);
      if (result.data["rows"][0]) {
        setParsingText(result.data["rows"][0]["parse_text"]);
        setModifiedTime(result.data["rows"][0]["modified_at"]);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    }

    setEeezoOpen(true);
  };

  const handleEeezoSubmit = async () => {
    console.log("entered value:::", newParse.current.value);
    let parseText = newParse.current.value;
    var userId;
    const encryptedMetadata = localStorage.getItem("metadata");
    if (encryptedMetadata) {
      const decryptedMetadata = JSON.parse(
        CryptoJS.AES.decrypt(
          encryptedMetadata,
          process.env.REACT_APP_SECRETKEY
        ).toString(CryptoJS.enc.Utf8)
      );
      if (decryptedMetadata.cid) {
        userId = Number(decryptedMetadata.uid);
      }
    }
    let currentTime = new Date();
    let modifiedDate = currentTime;
    console.log("current date: ", currentTime);
    console.log("opening submit userid:::", userId);
    console.log("current mail:::", currentMail);
    const setParse = {
      userID: userId,
      parseText: parseText,
      type: "eeezo",
      createdBy: currentMail,
      modified_at: modifiedDate,
    };

    try {
      const serverURL = process.env.REACT_APP_SERVER_URL;
      console.log("Fetching parsing text details...");
      const encryptedData = CryptoJS.AES.encrypt(
        JSON.stringify(setParse),
        process.env.REACT_APP_SECRETKEY
      ).toString();

      const response = await fetch(`${serverURL}/Triage/setParseText`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ data: encryptedData }),
      });
      const result = await response.json();
      console.log("Server Response getsync:", result);
      // setCurrentEmail(result.data["emails"][0]["syncmail"]);
      if (!response.ok) {
        const status = Swal.fire({
          icon: "warning",
          title: `Failed to update Parse Text!`,
          text: "",
          confirmButtonText: "OK",
          showCancelButton: true,
        });
        if (status.isConfirmed) {
          setEeezoOpen(false);
        }
        throw new Error(result.error);
      }

      if (response) {
        const status = Swal.fire({
          icon: "success",
          title: `Parse Text updated Successfully!`,
          text: "",
          confirmButtonText: "OK",
          showCancelButton: false,
        });
        if ((await status).isConfirmed) {
          setEeezoOpen(false);
        }
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const handleNaukri = async () => {
    console.log("settings....");
    var userId;
    const encryptedMetadata = localStorage.getItem("metadata");
    if (encryptedMetadata) {
      const decryptedMetadata = JSON.parse(
        CryptoJS.AES.decrypt(
          encryptedMetadata,
          process.env.REACT_APP_SECRETKEY
        ).toString(CryptoJS.enc.Utf8)
      );
      if (decryptedMetadata.cid) {
        userId = Number(decryptedMetadata.uid);
      }
    }
    console.log("opening userid:::", userId);
    const parseValue = { userID: userId, type: "naukri" };
    try {
      const serverURL = process.env.REACT_APP_SERVER_URL;
      console.log("Fetching parsing text details...");
      const encryptedData = CryptoJS.AES.encrypt(
        JSON.stringify(parseValue),
        process.env.REACT_APP_SECRETKEY
      ).toString();

      const response = await fetch(`${serverURL}/Triage/getParseText`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ data: encryptedData }),
      });
      const result = await response.json();
      console.log("Server Response getsync naukri:", result);
      setCurrentEmail(result.data["emails"][0]["syncmail"]);
      if (result.data["rows"][0]) {
        setNaukriParsing(result.data["rows"][0]["parse_text"]);
        setModifiedTime(result.data["rows"][0]["modified_at"]);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    }

    setNaukriOpen(true);
  };

  const handleNaukriSubmit = async () => {
    console.log("entered value:::", newParse.current.value);
    let parseText = newParse.current.value;
    var userId;
    const encryptedMetadata = localStorage.getItem("metadata");
    if (encryptedMetadata) {
      const decryptedMetadata = JSON.parse(
        CryptoJS.AES.decrypt(
          encryptedMetadata,
          process.env.REACT_APP_SECRETKEY
        ).toString(CryptoJS.enc.Utf8)
      );
      if (decryptedMetadata.cid) {
        userId = Number(decryptedMetadata.uid);
      }
    }
    let currentTime = new Date();
    let modifiedDate = currentTime;
    console.log("current date: ", currentTime);
    console.log("opening submit userid:::", userId);
    console.log("current mail:::", currentMail);
    const setParse = {
      userID: userId,
      parseText: parseText,
      type: "naukri",
      createdBy: currentMail,
      modified_at: modifiedDate,
    };

    try {
      const serverURL = process.env.REACT_APP_SERVER_URL;
      console.log("Fetching parsing text details...");
      const encryptedData = CryptoJS.AES.encrypt(
        JSON.stringify(setParse),
        process.env.REACT_APP_SECRETKEY
      ).toString();

      const response = await fetch(`${serverURL}/Triage/setParseText`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ data: encryptedData }),
      });
      const result = await response.json();
      console.log("Server Response getsync:", result);
      // setCurrentEmail(result.data["emails"][0]["syncmail"]);
      if (!response.ok) {
        const status = Swal.fire({
          icon: "warning",
          title: `Failed to update Parse Text!`,
          text: "",
          confirmButtonText: "OK",
          showCancelButton: true,
        });
        if (status.isConfirmed) {
          setEeezoOpen(false);
        }
        throw new Error(result.error);
      }

      if (response) {
        const status = Swal.fire({
          icon: "success",
          title: `Parse Text updated Successfully!`,
          text: "",
          confirmButtonText: "OK",
          showCancelButton: false,
        });
        if ((await status).isConfirmed) {
          setNaukriOpen(false);
        }
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const ModalBody = (
    <div>
      <p className="text-xs text-gray-500 mb-1">
        Current parsing text:{" "}
        <span className="text-md ml-2 font-[500]">
          {currentParsingText ? currentParsingText : "eeezo (default)"}
        </span>
      </p>
      <p className="text-xs text-gray-500 mb-1">
        Current mail:{" "}
        <span className="text-md ml-2 font-[500]">{currentMail}</span>
      </p>
      <p className="text-xs text-gray-500">
        created at:{" "}
        <span className="text-md ml-2 font-[500]">{modifiedTime}</span>
      </p>

      <Textinput
        label="Gmail Sync Text:"
        labelclass="!font-[400]"
        InputRef={newParse}
      />
      <p className="text-sm text-gray-500 mt-1">
        <span className="text-red-500">* </span>mails will be synched based on
        the sync text.
      </p>
      <Button
        className="text-white text-sm px-3 py-2  mt-2"
        onClick={() => handleEeezoSubmit()}
      >
        Submit
      </Button>
    </div>
  );

  const ModalBodyNaukri = (
    <div>
      <p className="text-xs text-gray-500 mb-1">
        Current parsing text:{" "}
        <span className="text-md ml-2 font-[500]">
          {naukriParsing ? naukriParsing : "Job ID:(default)"}
        </span>
      </p>
      <p className="text-xs text-gray-500 mb-1">
        Current mail:{" "}
        <span className="text-md ml-2 font-[500]">{currentMail}</span>
      </p>
      <p className="text-xs text-gray-500">
        created at:{" "}
        <span className="text-md ml-2 font-[500]">{modifiedTime}</span>
      </p>

      <Textinput
        label="Gmail Sync Text:"
        labelclass="!font-[400]"
        InputRef={newParse}
      />
      <p className="text-sm text-gray-500 mt-1">
        <span className="text-red-500">* </span>mails will be synched based on
        the sync text.
      </p>
      <Button
        className="text-white text-sm px-3 py-2  mt-2"
        onClick={() => handleNaukriSubmit()}
      >
        Submit
      </Button>
    </div>
  );

  return (
    <div className="relative min-h-screen bg-gray-50">
      {/* Modals */}
      {eeezoOpen && (
        <ModalBox
          Modal_Body={ModalBody}
          Modal_Header={
            <p className="text-xl mb-0 font-[500]">Schedule sync text</p>
          }
          modal_Close_Class="mb-3"
          cardClass="w-11/12 sm:w-8/12 md:w-6/12 lg:w-5/12"
          Modal_Close_Func={() => setEeezoOpen(false)}
        />
      )}
      {naukriOpen && (
        <ModalBox
          Modal_Body={ModalBodyNaukri}
          Modal_Header={
            <p className="text-xl mb-0 font-[500]">Naukri sync text</p>
          }
          modal_Close_Class="mb-3"
          cardClass="w-11/12 sm:w-8/12 md:w-6/12 lg:w-5/12"
          Modal_Close_Func={() => setNaukriOpen(false)}
        />
      )}

      {/* Mobile hamburger button */}
      <button
        className="lg:hidden top-4 left-4 z-50 p-2 bg-white rounded-md shadow-md ms-3"
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          {isSidebarOpen ? (
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          ) : (
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          )}
        </svg>
      </button>

      {/* Mobile overlay */}
      {isSidebarOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      <div className="flex h-full">
        {/* Sidebar */}
        <div
          className={`${
            isSidebarOpen ? "translate-x-0" : "-translate-x-full"
          } lg:translate-x-0 fixed lg:relative lg:flex flex-col w-80 lg:w-1/4 xl:w-1/5 bg-white shadow-lg z-50 transition-transform duration-300 ease-in-out h-screen lg:h-screen overflow-hidden inset-y-0`}
        >
          <div className="h-full overflow-y-auto">
            <div className="p-4 lg:p-6">
              {/* Close button for mobile */}
              <div className="lg:hidden flex justify-end mb-4">
                <button
                  onClick={() => setIsSidebarOpen(false)}
                  className="p-2 text-gray-500 hover:text-gray-700"
                >
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              <div className="border-b-2 pb-6 mb-6">
                <p
                  className={`flex mb-2 opacity-50 w-full py-3 rounded-lg pr-1 hover:cursor-pointer text-sm ${
                    currentSection === "Messages"
                      ? "bg-gradient-to-r from-gray-50 to-teal-300 px-2"
                      : "hover:bg-gray-50 px-2"
                  }`}
                  onClick={() => setCurrentSection("Messages")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    className="mt-[3px] mr-3 flex-shrink-0"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M8.46499 4.30809H8.46498V4.31032V5.84694C8.46498 6.64709 8.25486 7.17837 7.9217 7.51154C7.58853 7.8447 7.05724 8.05483 6.2571 8.05483H4.72048C3.92033 8.05483 3.38905 7.8447 3.05588 7.51154C2.72272 7.17837 2.51259 6.64709 2.51259 5.84694L2.51259 4.31032C2.51259 3.51018 2.7227 2.97917 3.05651 2.64611C3.39049 2.31287 3.92381 2.10244 4.72856 2.10244L6.26519 2.10244C7.06551 2.10244 7.59643 2.31264 7.92839 2.64534C8.26015 2.97785 8.46866 3.50836 8.46499 4.30809Z"
                      stroke="#059669"
                      strokeWidth="0.970498"
                    />
                    <path
                      d="M13.9724 2.10244L15.5091 2.10244C16.3092 2.10244 16.8405 2.31256 17.1736 2.64572C17.5068 2.97889 17.7169 3.51018 17.7169 4.31032V5.84694C17.7169 6.64709 17.5068 7.17837 17.1736 7.51154C16.8405 7.8447 16.3092 8.05483 15.5091 8.05483H13.9724C13.1723 8.05483 12.641 7.8447 12.3078 7.51154C11.9747 7.17837 11.7645 6.64709 11.7645 5.84694V4.31032C11.7645 3.51018 11.9747 2.97889 12.3078 2.64573C12.641 2.31256 13.1723 2.10244 13.9724 2.10244Z"
                      stroke="#059669"
                      strokeWidth="0.970498"
                    />
                    <path
                      d="M13.9724 11.3446H15.5091C16.3092 11.3446 16.8405 11.5547 17.1736 11.8879C17.5068 12.2211 17.7169 12.7524 17.7169 13.5525V15.0891C17.7169 15.8893 17.5068 16.4206 17.1736 16.7537C16.8405 17.0869 16.3092 17.297 15.5091 17.297H13.9724C13.1723 17.297 12.641 17.0869 12.3078 16.7537C11.9747 16.4206 11.7645 15.8893 11.7645 15.0891V13.5525C11.7645 12.7524 11.9747 12.2211 12.3078 11.8879C12.641 11.5547 13.1723 11.3446 13.9724 11.3446Z"
                      stroke="#059669"
                      strokeWidth="0.970498"
                    />
                    <path
                      d="M8.46499 13.5584H8.46498V13.5606V15.0972C8.46498 15.8974 8.25486 16.4286 7.9217 16.7618C7.58853 17.095 7.05724 17.3051 6.2571 17.3051H4.72048C3.92034 17.3051 3.38933 17.095 3.05626 16.7612C2.72302 16.4272 2.51259 15.8939 2.51259 15.0891L2.51259 13.5525C2.51259 12.7524 2.7227 12.2214 3.05651 11.8883C3.39049 11.5551 3.92381 11.3446 4.72856 11.3446H6.26519C7.0655 11.3446 7.59615 11.5548 7.92801 11.8882C8.25985 12.2215 8.46866 12.754 8.46499 13.5584Z"
                      stroke="#059669"
                      strokeWidth="0.970498"
                    />
                  </svg>
                  <span className="flex-1">Messages</span>
                  <span className="bg-yellow-500 ml-auto px-2 py-1 rounded-full text-xs">
                    10
                  </span>
                </p>

                <p
                  className={`flex mb-2 w-full opacity-50 py-3 rounded-lg pr-1 hover:cursor-pointer text-sm ${
                    currentSection === "Archieved"
                      ? "bg-gradient-to-r from-gray-50 to-teal-300 px-2"
                      : "hover:bg-gray-50 px-2"
                  }`}
                  onClick={() => setCurrentSection("Archieved")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    className="mt-[1px] mr-3 flex-shrink-0"
                    fill="none"
                  >
                    <path
                      d="M10.2453 16.2871H9.75358C9.17055 16.2863 8.69727 15.8138 8.69727 15.2308V12.5446C8.69727 11.9616 9.17057 11.4891 9.75358 11.4883H10.2453C10.8283 11.4891 11.3016 11.9616 11.3016 12.5446V15.2308C11.3016 15.8138 10.8283 16.2863 10.2453 16.2871ZM9.75358 12.0627C9.4869 12.0627 9.27146 12.2789 9.27066 12.5448V15.2309C9.27146 15.4968 9.4869 15.7131 9.75358 15.7131H10.2453C10.512 15.7131 10.7274 15.4968 10.7282 15.2309V12.5448C10.7274 12.2789 10.512 12.0627 10.2453 12.0627H9.75358Z"
                      fill="#059669"
                      stroke="#059669"
                      strokeWidth="0.25"
                    />
                    <path
                      d="M15.4866 7.9521C15.328 7.9521 15.1991 7.82397 15.1991 7.6654V5.76016C15.1991 4.22974 13.9538 2.98441 12.4234 2.98441H7.57651C6.04608 2.98441 4.80076 4.22974 4.80076 5.76016V7.6654C4.80076 7.82397 4.67182 7.9521 4.51326 7.9521C4.35469 7.9521 4.22656 7.82397 4.22656 7.6654V5.76016C4.22656 3.9126 5.72976 2.41016 7.57657 2.41016H12.4234C14.271 2.41016 15.7734 3.91335 15.7734 5.76016V7.6654C15.7734 7.74148 15.743 7.81436 15.6893 7.86802C15.6357 7.92168 15.5627 7.9521 15.4866 7.9521Z"
                      fill="#059669"
                      stroke="#059669"
                      strokeWidth="0.25"
                    />
                    <path
                      d="M13.7685 7.95049C13.61 7.95049 13.4818 7.82236 13.4818 7.66379V5.86988C13.481 5.1395 12.8884 4.54687 12.158 4.54607H7.84136C7.11098 4.54687 6.51836 5.1395 6.51756 5.86988V7.66379C6.51756 7.82236 6.38942 7.95049 6.23086 7.95049C6.07229 7.95049 5.94336 7.82236 5.94336 7.66379V5.86988C5.94496 4.82236 6.79386 3.97346 7.84138 3.97266H12.1581C13.2056 3.97346 14.0545 4.82236 14.0561 5.86988V7.66379C14.0561 7.82236 13.9271 7.95049 13.7685 7.95049Z"
                      fill="#059669"
                      stroke="#059669"
                      strokeWidth="0.25"
                    />
                    <path
                      d="M8.98443 13.9881C8.95961 13.9881 8.93478 13.9849 8.91075 13.9785L2.48239 12.2815C1.60866 12.0508 1 11.2604 1 10.357C1 10.1984 1.12814 10.0703 1.2867 10.0703C1.44526 10.0703 1.5734 10.1984 1.5734 10.357C1.5742 11.0001 2.00746 11.5623 2.62892 11.7265L9.05667 13.4235C9.19682 13.4603 9.28731 13.5949 9.2689 13.7382C9.25048 13.8808 9.12795 13.9881 8.9838 13.9881L8.98443 13.9881Z"
                      fill="#059669"
                      stroke="#059669"
                      strokeWidth="0.25"
                    />
                    <path
                      d="M11.0154 13.9881C10.8712 13.9881 10.7495 13.8808 10.7311 13.7382C10.7127 13.5949 10.8031 13.4603 10.9433 13.4235L17.3711 11.7265C17.9925 11.5623 18.4258 11.0001 18.4266 10.357C18.4266 10.1984 18.5547 10.0703 18.7133 10.0703C18.8718 10.0703 19 10.1984 19 10.357C19 11.2604 18.3913 12.0508 17.5176 12.2815L11.0892 13.9785C11.0652 13.9849 11.0402 13.9881 11.0154 13.9881Z"
                      fill="#059669"
                      stroke="#059669"
                      strokeWidth="0.25"
                    />
                    <path
                      d="M17.5128 19.149H2.48719C1.66631 19.1482 1.0008 18.4827 1 17.6618V8.86609C1.0008 8.04522 1.66631 7.37971 2.48719 7.37891H17.5128C18.3337 7.37971 18.9992 8.04522 19 8.86609V17.6618C18.9992 18.4827 18.3337 19.1482 17.5128 19.149ZM2.48719 7.95312C1.98266 7.95392 1.57422 8.36236 1.57342 8.86609V17.6618C1.57422 18.1655 1.98266 18.5748 2.48719 18.5748H17.5128C18.0173 18.5748 18.4258 18.1655 18.4266 17.6618V8.86609C18.4258 8.36236 18.0173 7.95392 17.5128 7.95312H2.48719Z"
                      fill="#059669"
                      stroke="#059669"
                      strokeWidth="0.25"
                    />
                  </svg>
                  <span className="flex-1">Archieved</span>
                </p>

                <p
                  className={`flex mb-2 w-full opacity-50 py-3 rounded-lg pr-1 hover:cursor-pointer text-sm ${
                    currentSection === "Drafts"
                      ? "bg-gradient-to-r from-gray-50 to-teal-300 px-2"
                      : "hover:bg-gray-50 px-2"
                  }`}
                  onClick={() => setCurrentSection("Drafts")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 21"
                    className="mt-[1px] mr-3 flex-shrink-0"
                    fill="#059669"
                  >
                    <path
                      d="M13.5465 3.70024V2.43859C13.5465 2.10701 13.2716 1.83203 12.94 1.83203C12.6084 1.83203 12.3334 2.10701 12.3334 2.43859V3.65172L7.07654 3.65172V2.43859C7.07654 2.10701 6.80157 1.83203 6.46998 1.83203C6.13839 1.83203 5.86342 2.10701 5.86342 2.43859V3.70024C3.6798 3.90243 2.62033 5.20451 2.45859 7.13742C2.44241 7.37196 2.63651 7.56606 2.86296 7.56606L16.547 7.56606C16.7815 7.56606 16.9756 7.36387 16.9514 7.13742C16.7896 5.20451 15.7302 3.90243 13.5465 3.70024Z"
                      fill="#059669"
                    />
                    <path
                      d="M16.175 8.77734L3.23499 8.77734C2.79018 8.77734 2.42624 9.14128 2.42624 9.58609L2.42624 14.568C2.42624 16.9942 3.63936 18.6117 6.46998 18.6117H12.94C15.7706 18.6117 16.9837 16.9942 16.9837 14.568V9.58609C16.9837 9.14128 16.6198 8.77734 16.175 8.77734ZM7.44857 15.5466C7.40813 15.5789 7.36769 15.6194 7.32726 15.6436C7.27873 15.676 7.23021 15.7002 7.18168 15.7164C7.13316 15.7407 7.08463 15.7568 7.03611 15.7649C6.97949 15.773 6.93097 15.7811 6.87436 15.7811C6.76922 15.7811 6.66408 15.7568 6.56703 15.7164C6.46189 15.676 6.38102 15.6194 6.30015 15.5466C6.15457 15.3929 6.06561 15.1826 6.06561 14.9724C6.06561 14.7621 6.15457 14.5518 6.30015 14.3981C6.38102 14.3254 6.46189 14.2687 6.56703 14.2283C6.71261 14.1636 6.87436 14.1474 7.03611 14.1798C7.08463 14.1879 7.13316 14.204 7.18168 14.2283C7.23021 14.2445 7.27873 14.2687 7.32726 14.3011C7.36769 14.3334 7.40813 14.3658 7.44857 14.3981C7.59414 14.5518 7.68311 14.7621 7.68311 14.9724C7.68311 15.1826 7.59414 15.3929 7.44857 15.5466ZM7.44857 12.7159C7.29491 12.8615 7.08463 12.9505 6.87436 12.9505C6.66408 12.9505 6.45381 12.8615 6.30015 12.7159C6.15457 12.5623 6.06561 12.352 6.06561 12.1417C6.06561 11.9315 6.15457 11.7212 6.30015 11.5675C6.52659 11.3411 6.88244 11.2683 7.18168 11.3977C7.28682 11.4381 7.37578 11.4947 7.44857 11.5675C7.59414 11.7212 7.68311 11.9315 7.68311 12.1417C7.68311 12.352 7.59414 12.5623 7.44857 12.7159ZM10.2792 15.5466C10.1255 15.6921 9.91525 15.7811 9.70498 15.7811C9.4947 15.7811 9.28443 15.6921 9.13077 15.5466C8.98519 15.3929 8.89623 15.1826 8.89623 14.9724C8.89623 14.7621 8.98519 14.5518 9.13077 14.3981C9.43 14.0989 9.97995 14.0989 10.2792 14.3981C10.4248 14.5518 10.5137 14.7621 10.5137 14.9724C10.5137 15.1826 10.4248 15.3929 10.2792 15.5466ZM10.2792 12.7159C10.2388 12.7483 10.1983 12.7806 10.1579 12.813C10.1094 12.8453 10.0608 12.8696 10.0123 12.8858C9.96378 12.91 9.91525 12.9262 9.86673 12.9343C9.81011 12.9424 9.76159 12.9505 9.70498 12.9505C9.4947 12.9505 9.28443 12.8615 9.13077 12.7159C8.98519 12.5623 8.89623 12.352 8.89623 12.1417C8.89623 11.9315 8.98519 11.7212 9.13077 11.5675C9.20355 11.4947 9.29252 11.4381 9.39765 11.3977C9.69689 11.2683 10.0527 11.3411 10.2792 11.5675C10.4248 11.7212 10.5137 11.9315 10.5137 12.1417C10.5137 12.352 10.4248 12.5623 10.2792 12.7159ZM13.1098 15.5466C12.9561 15.6921 12.7459 15.7811 12.5356 15.7811C12.3253 15.7811 12.115 15.6921 11.9614 15.5466C11.8158 15.3929 11.7268 15.1826 11.7268 14.9724C11.7268 14.7621 11.8158 14.5518 11.9614 14.3981C12.2606 14.0989 12.8106 14.0989 13.1098 14.3981C13.2554 14.5518 13.3443 14.7621 13.3443 14.9724C13.3443 15.1826 13.2554 15.3929 13.1098 15.5466ZM13.1098 12.7159C13.0694 12.7483 13.0289 12.7806 12.9885 12.813C12.94 12.8453 12.8914 12.8696 12.8429 12.8858C12.7944 12.91 12.7459 12.9262 12.6973 12.9343C12.6407 12.9424 12.5841 12.9505 12.5356 12.9505C12.3253 12.9505 12.115 12.8615 11.9614 12.7159C11.8158 12.5623 11.7268 12.352 11.7268 12.1417C11.7268 11.9315 11.8158 11.7212 11.9614 11.5675C12.0423 11.4947 12.1231 11.4381 12.2283 11.3977C12.3738 11.333 12.5356 11.3168 12.6973 11.3492C12.7459 11.3573 12.7944 11.3734 12.8429 11.3977C12.8914 11.4139 12.94 11.4381 12.9885 11.4705C13.0289 11.5028 13.0694 11.5352 13.1098 11.5675C13.2554 11.7212 13.3443 11.9315 13.3443 12.1417C13.3443 12.352 13.2554 12.5623 13.1098 12.7159Z"
                      fill="#059669"
                    />
                  </svg>
                  <span className="flex-1">Drafts</span>
                </p>
              </div>

              <div className="mb-6">
                <p
                  className={`flex mb-2 w-full py-3 rounded-lg pr-1 hover:cursor-pointer text-sm ${
                    currentSection === "Email Dashboard"
                      ? "bg-gradient-to-r from-gray-50 to-teal-300 px-2"
                      : "hover:bg-gray-50 px-2"
                  }`}
                  onClick={() => handleSections("Email Dashboard")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    className="mt-[3px] mr-3 flex-shrink-0"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M8.46499 4.30809H8.46498V4.31032V5.84694C8.46498 6.64709 8.25486 7.17837 7.9217 7.51154C7.58853 7.8447 7.05724 8.05483 6.2571 8.05483H4.72048C3.92033 8.05483 3.38905 7.8447 3.05588 7.51154C2.72272 7.17837 2.51259 6.64709 2.51259 5.84694L2.51259 4.31032C2.51259 3.51018 2.7227 2.97917 3.05651 2.64611C3.39049 2.31287 3.92381 2.10244 4.72856 2.10244L6.26519 2.10244C7.06551 2.10244 7.59643 2.31264 7.92839 2.64534C8.26015 2.97785 8.46866 3.50836 8.46499 4.30809Z"
                      stroke="#059669"
                      strokeWidth="0.970498"
                    />
                    <path
                      d="M13.9724 2.10244L15.5091 2.10244C16.3092 2.10244 16.8405 2.31256 17.1736 2.64572C17.5068 2.97889 17.7169 3.51018 17.7169 4.31032V5.84694C17.7169 6.64709 17.5068 7.17837 17.1736 7.51154C16.8405 7.8447 16.3092 8.05483 15.5091 8.05483H13.9724C13.1723 8.05483 12.641 7.8447 12.3078 7.51154C11.9747 7.17837 11.7645 6.64709 11.7645 5.84694V4.31032C11.7645 3.51018 11.9747 2.97889 12.3078 2.64573C12.641 2.31256 13.1723 2.10244 13.9724 2.10244Z"
                      stroke="#059669"
                      strokeWidth="0.970498"
                    />
                    <path
                      d="M13.9724 11.3446H15.5091C16.3092 11.3446 16.8405 11.5547 17.1736 11.8879C17.5068 12.2211 17.7169 12.7524 17.7169 13.5525V15.0891C17.7169 15.8893 17.5068 16.4206 17.1736 16.7537C16.8405 17.0869 16.3092 17.297 15.5091 17.297H13.9724C13.1723 17.297 12.641 17.0869 12.3078 16.7537C11.9747 16.4206 11.7645 15.8893 11.7645 15.0891V13.5525C11.7645 12.7524 11.9747 12.2211 12.3078 11.8879C12.641 11.5547 13.1723 11.3446 13.9724 11.3446Z"
                      stroke="#059669"
                      strokeWidth="0.970498"
                    />
                    <path
                      d="M8.46499 13.5584H8.46498V13.5606V15.0972C8.46498 15.8974 8.25486 16.4286 7.9217 16.7618C7.58853 17.095 7.05724 17.3051 6.2571 17.3051H4.72048C3.92034 17.3051 3.38933 17.095 3.05626 16.7612C2.72302 16.4272 2.51259 15.8939 2.51259 15.0891L2.51259 13.5525C2.51259 12.7524 2.7227 12.2214 3.05651 11.8883C3.39049 11.5551 3.92381 11.3446 4.72856 11.3446H6.26519C7.0655 11.3446 7.59615 11.5548 7.92801 11.8882C8.25985 12.2215 8.46866 12.754 8.46499 13.5584Z"
                      stroke="#059669"
                      strokeWidth="0.970498"
                    />
                  </svg>
                  <span className="flex-1">Email Dashboard</span>
                </p>

                <p
                  className={`flex mb-2 w-full opacity-50 py-3 rounded-lg pr-1 hover:cursor-pointer text-sm ${
                    currentSection === "Actions Management"
                      ? "bg-gradient-to-r from-gray-50 to-teal-300 px-2"
                      : "hover:bg-gray-50 px-2"
                  }`}
                  onClick={() => setCurrentSection("Actions Management")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    className="mt-[3px] mr-3 flex-shrink-0"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M8.46499 4.30809H8.46498V4.31032V5.84694C8.46498 6.64709 8.25486 7.17837 7.9217 7.51154C7.58853 7.8447 7.05724 8.05483 6.2571 8.05483H4.72048C3.92033 8.05483 3.38905 7.8447 3.05588 7.51154C2.72272 7.17837 2.51259 6.64709 2.51259 5.84694L2.51259 4.31032C2.51259 3.51018 2.7227 2.97917 3.05651 2.64611C3.39049 2.31287 3.92381 2.10244 4.72856 2.10244L6.26519 2.10244C7.06551 2.10244 7.59643 2.31264 7.92839 2.64534C8.26015 2.97785 8.46866 3.50836 8.46499 4.30809Z"
                      stroke="#059669"
                      strokeWidth="0.970498"
                    />
                    <path
                      d="M13.9724 2.10244L15.5091 2.10244C16.3092 2.10244 16.8405 2.31256 17.1736 2.64572C17.5068 2.97889 17.7169 3.51018 17.7169 4.31032V5.84694C17.7169 6.64709 17.5068 7.17837 17.1736 7.51154C16.8405 7.8447 16.3092 8.05483 15.5091 8.05483H13.9724C13.1723 8.05483 12.641 7.8447 12.3078 7.51154C11.9747 7.17837 11.7645 6.64709 11.7645 5.84694V4.31032C11.7645 3.51018 11.9747 2.97889 12.3078 2.64573C12.641 2.31256 13.1723 2.10244 13.9724 2.10244Z"
                      stroke="#059669"
                      strokeWidth="0.970498"
                    />
                    <path
                      d="M13.9724 11.3446H15.5091C16.3092 11.3446 16.8405 11.5547 17.1736 11.8879C17.5068 12.2211 17.7169 12.7524 17.7169 13.5525V15.0891C17.7169 15.8893 17.5068 16.4206 17.1736 16.7537C16.8405 17.0869 16.3092 17.297 15.5091 17.297H13.9724C13.1723 17.297 12.641 17.0869 12.3078 16.7537C11.9747 16.4206 11.7645 15.8893 11.7645 15.0891V13.5525C11.7645 12.7524 11.9747 12.2211 12.3078 11.8879C12.641 11.5547 13.1723 11.3446 13.9724 11.3446Z"
                      stroke="#059669"
                      strokeWidth="0.970498"
                    />
                    <path
                      d="M8.46499 13.5584H8.46498V13.5606V15.0972C8.46498 15.8974 8.25486 16.4286 7.9217 16.7618C7.58853 17.095 7.05724 17.3051 6.2571 17.3051H4.72048C3.92034 17.3051 3.38933 17.095 3.05626 16.7612C2.72302 16.4272 2.51259 15.8939 2.51259 15.0891L2.51259 13.5525C2.51259 12.7524 2.7227 12.2214 3.05651 11.8883C3.39049 11.5551 3.92381 11.3446 4.72856 11.3446H6.26519C7.0655 11.3446 7.59615 11.5548 7.92801 11.8882C8.25985 12.2215 8.46866 12.754 8.46499 13.5584Z"
                      stroke="#059669"
                      strokeWidth="0.970498"
                    />
                  </svg>
                  <span className="flex-1">Actions Management</span>
                </p>

                <p
                  className={`flex mb-2 w-full opacity-50 py-3 rounded-lg pr-1 hover:cursor-pointer text-sm ${
                    currentSection === "Reports"
                      ? "bg-gradient-to-r from-gray-50 to-teal-300 px-2"
                      : "hover:bg-gray-50 px-2"
                  }`}
                  onClick={() => setCurrentSection("Reports")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    className="mt-[3px] mr-3 flex-shrink-0"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M8.46499 4.30809H8.46498V4.31032V5.84694C8.46498 6.64709 8.25486 7.17837 7.9217 7.51154C7.58853 7.8447 7.05724 8.05483 6.2571 8.05483H4.72048C3.92033 8.05483 3.38905 7.8447 3.05588 7.51154C2.72272 7.17837 2.51259 6.64709 2.51259 5.84694L2.51259 4.31032C2.51259 3.51018 2.7227 2.97917 3.05651 2.64611C3.39049 2.31287 3.92381 2.10244 4.72856 2.10244L6.26519 2.10244C7.06551 2.10244 7.59643 2.31264 7.92839 2.64534C8.26015 2.97785 8.46866 3.50836 8.46499 4.30809Z"
                      stroke="#059669"
                      strokeWidth="0.970498"
                    />
                    <path
                      d="M13.9724 2.10244L15.5091 2.10244C16.3092 2.10244 16.8405 2.31256 17.1736 2.64572C17.5068 2.97889 17.7169 3.51018 17.7169 4.31032V5.84694C17.7169 6.64709 17.5068 7.17837 17.1736 7.51154C16.8405 7.8447 16.3092 8.05483 15.5091 8.05483H13.9724C13.1723 8.05483 12.641 7.8447 12.3078 7.51154C11.9747 7.17837 11.7645 6.64709 11.7645 5.84694V4.31032C11.7645 3.51018 11.9747 2.97889 12.3078 2.64573C12.641 2.31256 13.1723 2.10244 13.9724 2.10244Z"
                      stroke="#059669"
                      strokeWidth="0.970498"
                    />
                    <path
                      d="M13.9724 11.3446H15.5091C16.3092 11.3446 16.8405 11.5547 17.1736 11.8879C17.5068 12.2211 17.7169 12.7524 17.7169 13.5525V15.0891C17.7169 15.8893 17.5068 16.4206 17.1736 16.7537C16.8405 17.0869 16.3092 17.297 15.5091 17.297H13.9724C13.1723 17.297 12.641 17.0869 12.3078 16.7537C11.9747 16.4206 11.7645 15.8893 11.7645 15.0891V13.5525C11.7645 12.7524 11.9747 12.2211 12.3078 11.8879C12.641 11.5547 13.1723 11.3446 13.9724 11.3446Z"
                      stroke="#059669"
                      strokeWidth="0.970498"
                    />
                    <path
                      d="M8.46499 13.5584H8.46498V13.5606V15.0972C8.46498 15.8974 8.25486 16.4286 7.9217 16.7618C7.58853 17.095 7.05724 17.3051 6.2571 17.3051H4.72048C3.92034 17.3051 3.38933 17.095 3.05626 16.7612C2.72302 16.4272 2.51259 15.8939 2.51259 15.0891L2.51259 13.5525C2.51259 12.7524 2.7227 12.2214 3.05651 11.8883C3.39049 11.5551 3.92381 11.3446 4.72856 11.3446H6.26519C7.0655 11.3446 7.59615 11.5548 7.92801 11.8882C8.25985 12.2215 8.46866 12.754 8.46499 13.5584Z"
                      stroke="#059669"
                      strokeWidth="0.970498"
                    />
                  </svg>
                  <span className="flex-1">Reports</span>
                </p>
              </div>

              <div>
                <p className="font-[500] mb-4 text-lg">Sections</p>
                <p
                  className={`flex mb-2 w-full py-3 rounded-lg pr-1 hover:cursor-pointer text-sm ${
                    currentSection === "Schedule"
                      ? "bg-gradient-to-r from-gray-50 to-teal-300 px-2"
                      : "hover:bg-gray-50 px-2"
                  }`}
                  onClick={() => handleSections("Schedule")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    className="mt-[3px] mr-3 flex-shrink-0"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M8.46499 4.30809H8.46498V4.31032V5.84694C8.46498 6.64709 8.25486 7.17837 7.9217 7.51154C7.58853 7.8447 7.05724 8.05483 6.2571 8.05483H4.72048C3.92033 8.05483 3.38905 7.8447 3.05588 7.51154C2.72272 7.17837 2.51259 6.64709 2.51259 5.84694L2.51259 4.31032C2.51259 3.51018 2.7227 2.97917 3.05651 2.64611C3.39049 2.31287 3.92381 2.10244 4.72856 2.10244L6.26519 2.10244C7.06551 2.10244 7.59643 2.31264 7.92839 2.64534C8.26015 2.97785 8.46866 3.50836 8.46499 4.30809Z"
                      stroke="#059669"
                      strokeWidth="0.970498"
                    />
                    <path
                      d="M13.9724 2.10244L15.5091 2.10244C16.3092 2.10244 16.8405 2.31256 17.1736 2.64572C17.5068 2.97889 17.7169 3.51018 17.7169 4.31032V5.84694C17.7169 6.64709 17.5068 7.17837 17.1736 7.51154C16.8405 7.8447 16.3092 8.05483 15.5091 8.05483H13.9724C13.1723 8.05483 12.641 7.8447 12.3078 7.51154C11.9747 7.17837 11.7645 6.64709 11.7645 5.84694V4.31032C11.7645 3.51018 11.9747 2.97889 12.3078 2.64573C12.641 2.31256 13.1723 2.10244 13.9724 2.10244Z"
                      stroke="#059669"
                      strokeWidth="0.970498"
                    />
                    <path
                      d="M13.9724 11.3446H15.5091C16.3092 11.3446 16.8405 11.5547 17.1736 11.8879C17.5068 12.2211 17.7169 12.7524 17.7169 13.5525V15.0891C17.7169 15.8893 17.5068 16.4206 17.1736 16.7537C16.8405 17.0869 16.3092 17.297 15.5091 17.297H13.9724C13.1723 17.297 12.641 17.0869 12.3078 16.7537C11.9747 16.4206 11.7645 15.8893 11.7645 15.0891V13.5525C11.7645 12.7524 11.9747 12.2211 12.3078 11.8879C12.641 11.5547 13.1723 11.3446 13.9724 11.3446Z"
                      stroke="#059669"
                      strokeWidth="0.970498"
                    />
                    <path
                      d="M8.46499 13.5584H8.46498V13.5606V15.0972C8.46498 15.8974 8.25486 16.4286 7.9217 16.7618C7.58853 17.095 7.05724 17.3051 6.2571 17.3051H4.72048C3.92034 17.3051 3.38933 17.095 3.05626 16.7612C2.72302 16.4272 2.51259 15.8939 2.51259 15.0891L2.51259 13.5525C2.51259 12.7524 2.7227 12.2214 3.05651 11.8883C3.39049 11.5551 3.92381 11.3446 4.72856 11.3446H6.26519C7.0655 11.3446 7.59615 11.5548 7.92801 11.8882C8.25985 12.2215 8.46866 12.754 8.46499 13.5584Z"
                      stroke="#059669"
                      strokeWidth="0.970498"
                    />
                  </svg>
                  <span className="flex-1">Schedule</span>
                  <button
                    className="ml-auto p-1 hover:bg-gray-100 rounded"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleschedule();
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 50 50"
                    >
                      <path d="M 22.205078 2 A 1.0001 1.0001 0 0 0 21.21875 2.8378906 L 20.246094 8.7929688 C 19.076509 9.1331971 17.961243 9.5922728 16.910156 10.164062 L 11.996094 6.6542969 A 1.0001 1.0001 0 0 0 10.708984 6.7597656 L 6.8183594 10.646484 A 1.0001 1.0001 0 0 0 6.7070312 11.927734 L 10.164062 16.873047 C 9.583454 17.930271 9.1142098 19.051824 8.765625 20.232422 L 2.8359375 21.21875 A 1.0001 1.0001 0 0 0 2.0019531 22.205078 L 2.0019531 27.705078 A 1.0001 1.0001 0 0 0 2.8261719 28.691406 L 8.7597656 29.742188 C 9.1064607 30.920739 9.5727226 32.043065 10.154297 33.101562 L 6.6542969 37.998047 A 1.0001 1.0001 0 0 0 6.7597656 39.285156 L 10.648438 43.175781 A 1.0001 1.0001 0 0 0 11.927734 43.289062 L 16.882812 39.820312 C 17.936999 40.39548 19.054994 40.857928 20.228516 41.201172 L 21.21875 47.164062 A 1.0001 1.0001 0 0 0 22.205078 48 L 27.705078 48 A 1.0001 1.0001 0 0 0 28.691406 47.173828 L 29.751953 41.1875 C 30.920633 40.838997 32.033372 40.369697 33.082031 39.791016 L 38.070312 43.291016 A 1.0001 1.0001 0 0 0 39.351562 43.179688 L 43.240234 39.287109 A 1.0001 1.0001 0 0 0 43.34375 37.996094 L 39.787109 33.058594 C 40.355783 32.014958 40.813915 30.908875 41.154297 29.748047 L 47.171875 28.693359 A 1.0001 1.0001 0 0 0 47.998047 27.707031 L 47.998047 22.207031 A 1.0001 1.0001 0 0 0 47.160156 21.220703 L 41.152344 20.238281 C 40.80968 19.078827 40.350281 17.974723 39.78125 16.931641 L 43.289062 11.933594 A 1.0001 1.0001 0 0 0 43.177734 10.652344 L 39.287109 6.7636719 A 1.0001 1.0001 0 0 0 37.996094 6.6601562 L 33.072266 10.201172 C 32.023186 9.6248101 30.909713 9.1579916 29.738281 8.8125 L 28.691406 2.828125 A 1.0001 1.0001 0 0 0 27.705078 2 L 22.205078 2 z M 23.056641 4 L 26.865234 4 L 27.861328 9.6855469 A 1.0001 1.0001 0 0 0 28.603516 10.484375 C 30.066026 10.848832 31.439607 11.426549 32.693359 12.185547 A 1.0001 1.0001 0 0 0 33.794922 12.142578 L 38.474609 8.7792969 L 41.167969 11.472656 L 37.835938 16.220703 A 1.0001 1.0001 0 0 0 37.796875 17.310547 C 38.548366 18.561471 39.118333 19.926379 39.482422 21.380859 A 1.0001 1.0001 0 0 0 40.291016 22.125 L 45.998047 23.058594 L 45.998047 26.867188 L 40.279297 27.871094 A 1.0001 1.0001 0 0 0 39.482422 28.617188 C 39.122545 30.069817 38.552234 31.434687 37.800781 32.685547 A 1.0001 1.0001 0 0 0 37.845703 33.785156 L 41.224609 38.474609 L 38.53125 41.169922 L 33.791016 37.84375 A 1.0001 1.0001 0 0 0 32.697266 37.808594 C 31.44975 38.567585 30.074755 39.148028 28.617188 39.517578 A 1.0001 1.0001 0 0 0 27.876953 40.3125 L 26.867188 46 L 23.052734 46 L 22.111328 40.337891 A 1.0001 1.0001 0 0 0 21.365234 39.53125 C 19.90185 39.170557 18.522094 38.59371 17.259766 37.835938 A 1.0001 1.0001 0 0 0 16.171875 37.875 L 11.46875 41.169922 L 8.7734375 38.470703 L 12.097656 33.824219 A 1.0001 1.0001 0 0 0 12.138672 32.724609 C 11.372652 31.458855 10.793319 30.079213 10.427734 28.609375 A 1.0001 1.0001 0 0 0 9.6328125 27.867188 L 4.0019531 26.867188 L 4.0019531 23.052734 L 9.6289062 22.117188 A 1.0001 1.0001 0 0 0 10.435547 21.373047 C 10.804273 19.898143 11.383325 18.518729 12.146484 17.255859 A 1.0001 1.0001 0 0 0 12.111328 16.164062 L 8.8261719 11.46875 L 11.523438 8.7734375 L 16.185547 12.105469 A 1.0001 1.0001 0 0 0 17.28125 12.148438 C 18.536908 11.394293 19.919867 10.822081 21.384766 10.462891 A 1.0001 1.0001 0 0 0 22.132812 9.6523438 L 23.056641 4 z M 25 17 C 20.593567 17 17 20.593567 17 25 C 17 29.406433 20.593567 33 25 33 C 29.406433 33 33 29.406433 33 25 C 33 20.593567 29.406433 17 25 17 z M 25 19 C 28.325553 19 31 21.674447 31 25 C 31 28.325553 28.325553 31 25 31 C 21.674447 31 19 28.325553 19 25 C 19 21.674447 21.674447 19 25 19 z"></path>
                    </svg>
                  </button>
                </p>

                <p
                  className={`flex mb-2 w-full py-3 rounded-lg pr-1 hover:cursor-pointer text-sm ${
                    currentSection === "naukri"
                      ? "bg-gradient-to-r from-gray-50 to-teal-300 px-2"
                      : "hover:bg-gray-50 px-2"
                  }`}
                  onClick={() => handleSections("naukri")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    className="mt-[3px] mr-3 flex-shrink-0"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M8.46499 4.30809H8.46498V4.31032V5.84694C8.46498 6.64709 8.25486 7.17837 7.9217 7.51154C7.58853 7.8447 7.05724 8.05483 6.2571 8.05483H4.72048C3.92033 8.05483 3.38905 7.8447 3.05588 7.51154C2.72272 7.17837 2.51259 6.64709 2.51259 5.84694L2.51259 4.31032C2.51259 3.51018 2.7227 2.97917 3.05651 2.64611C3.39049 2.31287 3.92381 2.10244 4.72856 2.10244L6.26519 2.10244C7.06551 2.10244 7.59643 2.31264 7.92839 2.64534C8.26015 2.97785 8.46866 3.50836 8.46499 4.30809Z"
                      stroke="#059669"
                      strokeWidth="0.970498"
                    />
                    <path
                      d="M13.9724 2.10244L15.5091 2.10244C16.3092 2.10244 16.8405 2.31256 17.1736 2.64572C17.5068 2.97889 17.7169 3.51018 17.7169 4.31032V5.84694C17.7169 6.64709 17.5068 7.17837 17.1736 7.51154C16.8405 7.8447 16.3092 8.05483 15.5091 8.05483H13.9724C13.1723 8.05483 12.641 7.8447 12.3078 7.51154C11.9747 7.17837 11.7645 6.64709 11.7645 5.84694V4.31032C11.7645 3.51018 11.9747 2.97889 12.3078 2.64573C12.641 2.31256 13.1723 2.10244 13.9724 2.10244Z"
                      stroke="#059669"
                      strokeWidth="0.970498"
                    />
                    <path
                      d="M13.9724 11.3446H15.5091C16.3092 11.3446 16.8405 11.5547 17.1736 11.8879C17.5068 12.2211 17.7169 12.7524 17.7169 13.5525V15.0891C17.7169 15.8893 17.5068 16.4206 17.1736 16.7537C16.8405 17.0869 16.3092 17.297 15.5091 17.297H13.9724C13.1723 17.297 12.641 17.0869 12.3078 16.7537C11.9747 16.4206 11.7645 15.8893 11.7645 15.0891V13.5525C11.7645 12.7524 11.9747 12.2211 12.3078 11.8879C12.641 11.5547 13.1723 11.3446 13.9724 11.3446Z"
                      stroke="#059669"
                      strokeWidth="0.970498"
                    />
                    <path
                      d="M8.46499 13.5584H8.46498V13.5606V15.0972C8.46498 15.8974 8.25486 16.4286 7.9217 16.7618C7.58853 17.095 7.05724 17.3051 6.2571 17.3051H4.72048C3.92034 17.3051 3.38933 17.095 3.05626 16.7612C2.72302 16.4272 2.51259 15.8939 2.51259 15.0891L2.51259 13.5525C2.51259 12.7524 2.7227 12.2214 3.05651 11.8883C3.39049 11.5551 3.92381 11.3446 4.72856 11.3446H6.26519C7.0655 11.3446 7.59615 11.5548 7.92801 11.8882C8.25985 12.2215 8.46866 12.754 8.46499 13.5584Z"
                      stroke="#059669"
                      strokeWidth="0.970498"
                    />
                  </svg>
                  <span className="flex-1">Naukri</span>
                  <button
                    className="ml-auto p-1 hover:bg-gray-100 rounded"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleNaukri();
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 50 50"
                    >
                      <path d="M 22.205078 2 A 1.0001 1.0001 0 0 0 21.21875 2.8378906 L 20.246094 8.7929688 C 19.076509 9.1331971 17.961243 9.5922728 16.910156 10.164062 L 11.996094 6.6542969 A 1.0001 1.0001 0 0 0 10.708984 6.7597656 L 6.8183594 10.646484 A 1.0001 1.0001 0 0 0 6.7070312 11.927734 L 10.164062 16.873047 C 9.583454 17.930271 9.1142098 19.051824 8.765625 20.232422 L 2.8359375 21.21875 A 1.0001 1.0001 0 0 0 2.0019531 22.205078 L 2.0019531 27.705078 A 1.0001 1.0001 0 0 0 2.8261719 28.691406 L 8.7597656 29.742188 C 9.1064607 30.920739 9.5727226 32.043065 10.154297 33.101562 L 6.6542969 37.998047 A 1.0001 1.0001 0 0 0 6.7597656 39.285156 L 10.648438 43.175781 A 1.0001 1.0001 0 0 0 11.927734 43.289062 L 16.882812 39.820312 C 17.936999 40.39548 19.054994 40.857928 20.228516 41.201172 L 21.21875 47.164062 A 1.0001 1.0001 0 0 0 22.205078 48 L 27.705078 48 A 1.0001 1.0001 0 0 0 28.691406 47.173828 L 29.751953 41.1875 C 30.920633 40.838997 32.033372 40.369697 33.082031 39.791016 L 38.070312 43.291016 A 1.0001 1.0001 0 0 0 39.351562 43.179688 L 43.240234 39.287109 A 1.0001 1.0001 0 0 0 43.34375 37.996094 L 39.787109 33.058594 C 40.355783 32.014958 40.813915 30.908875 41.154297 29.748047 L 47.171875 28.693359 A 1.0001 1.0001 0 0 0 47.998047 27.707031 L 47.998047 22.207031 A 1.0001 1.0001 0 0 0 47.160156 21.220703 L 41.152344 20.238281 C 40.80968 19.078827 40.350281 17.974723 39.78125 16.931641 L 43.289062 11.933594 A 1.0001 1.0001 0 0 0 43.177734 10.652344 L 39.287109 6.7636719 A 1.0001 1.0001 0 0 0 37.996094 6.6601562 L 33.072266 10.201172 C 32.023186 9.6248101 30.909713 9.1579916 29.738281 8.8125 L 28.691406 2.828125 A 1.0001 1.0001 0 0 0 27.705078 2 L 22.205078 2 z M 23.056641 4 L 26.865234 4 L 27.861328 9.6855469 A 1.0001 1.0001 0 0 0 28.603516 10.484375 C 30.066026 10.848832 31.439607 11.426549 32.693359 12.185547 A 1.0001 1.0001 0 0 0 33.794922 12.142578 L 38.474609 8.7792969 L 41.167969 11.472656 L 37.835938 16.220703 A 1.0001 1.0001 0 0 0 37.796875 17.310547 C 38.548366 18.561471 39.118333 19.926379 39.482422 21.380859 A 1.0001 1.0001 0 0 0 40.291016 22.125 L 45.998047 23.058594 L 45.998047 26.867188 L 40.279297 27.871094 A 1.0001 1.0001 0 0 0 39.482422 28.617188 C 39.122545 30.069817 38.552234 31.434687 37.800781 32.685547 A 1.0001 1.0001 0 0 0 37.845703 33.785156 L 41.224609 38.474609 L 38.53125 41.169922 L 33.791016 37.84375 A 1.0001 1.0001 0 0 0 32.697266 37.808594 C 31.44975 38.567585 30.074755 39.148028 28.617188 39.517578 A 1.0001 1.0001 0 0 0 27.876953 40.3125 L 26.867188 46 L 23.052734 46 L 22.111328 40.337891 A 1.0001 1.0001 0 0 0 21.365234 39.53125 C 19.90185 39.170557 18.522094 38.59371 17.259766 37.835938 A 1.0001 1.0001 0 0 0 16.171875 37.875 L 11.46875 41.169922 L 8.7734375 38.470703 L 12.097656 33.824219 A 1.0001 1.0001 0 0 0 12.138672 32.724609 C 11.372652 31.458855 10.793319 30.079213 10.427734 28.609375 A 1.0001 1.0001 0 0 0 9.6328125 27.867188 L 4.0019531 26.867188 L 4.0019531 23.052734 L 9.6289062 22.117188 A 1.0001 1.0001 0 0 0 10.435547 21.373047 C 10.804273 19.898143 11.383325 18.518729 12.146484 17.255859 A 1.0001 1.0001 0 0 0 12.111328 16.164062 L 8.8261719 11.46875 L 11.523438 8.7734375 L 16.185547 12.105469 A 1.0001 1.0001 0 0 0 17.28125 12.148438 C 18.536908 11.394293 19.919867 10.822081 21.384766 10.462891 A 1.0001 1.0001 0 0 0 22.132812 9.6523438 L 23.056641 4 z M 25 17 C 20.593567 17 17 20.593567 17 25 C 17 29.406433 20.593567 33 25 33 C 29.406433 33 33 29.406433 33 25 C 33 20.593567 29.406433 17 25 17 z M 25 19 C 28.325553 19 31 21.674447 31 25 C 31 28.325553 28.325553 31 25 31 C 21.674447 31 19 28.325553 19 25 C 19 21.674447 21.674447 19 25 19 z"></path>
                    </svg>
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="flex-1 lg:ml-0 min-h-screen bg-white bg-opacity-50 rounded-xl lg:rounded-l-none">
          <div className="p-4 lg:p-6 lg:pl-8 pt-16 lg:pt-6">
            {currentSection === "Email Dashboard" ? <Triage /> : ""}
            {currentSection === "Schedule" ? <Triage /> : ""}
            {currentSection === "naukri" ? <Triage /> : ""}
            {currentSection === "Actions Management" ? (
              <ActionManagement />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailSidebar;
